import * as React from 'react';

import { cn } from '@/lib/utils';

export function CodeCli({
  highlightedFeature,
}: {
  highlightedFeature: string | null;
}) {
  return (
    <div
      className={cn(
        'bg-background p-4 border shadow-xl shadow-background transition-all duration-300 rounded-lg',
        {
          'bg-halfmast-1100 ring-2 ring-primary': highlightedFeature === 'cli',
        },
      )}
    >
      <pre
        className={cn(
          'bg-transparent whitespace-pre-wrap break-words overflow-x-auto mb-2',
        )}
      >
        <code className={cn('text-xs md:text-sm text-white', 'font-mono')}>
          <span className="text-gray-500">$</span>{' '}
          <span className="text-yellow-600">npx</span> flagsync generate
          <br />
          <br />
          <span className="text-primary">✓</span> Select your SDK:{' '}
          <span className="text-cyan-500">React</span>
          <br />
          <span className="text-cyan-500">i</span> Found 4 flags
          <br />
          <span
            className={cn(
              'inline-block -indent-4 pl-4 rounded transition-all duration-300',
              {
                'bg-primary/20 pl-6 pr-2': highlightedFeature === 'types',
              },
            )}
          >
            <span className="text-primary">✓</span> Generated flag types, saved
            to <span className="text-amber-700">&#34;gen\flags.d.ts&#34;</span>
          </span>
          <br />
        </code>
      </pre>
    </div>
  );
}
